import styled from "@emotion/styled";
import { TextField } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { getLocale } from "react-i18nify";
import SearchIcon from "@mui/icons-material/Search";

const WrapperText = styled.div`
  width: 100%;
  max-width: 475px;
  min-width: 265px;
  position: relative;
  display: flex;
  justify-content: center;
  .TextField-without-border-radius fieldset {
    border-radius: 16px;
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: unset;
  }
`;

const SearchInput = ({ onSearch = () => {}, setDataSearch = () => {} }) => {
  return (
    <WrapperText>
      <TextField
        id="search-input"
        placeholder={
          getLocale() === "th"
            ? `ค้นหาจากชื่อลูกค้า, เลขคำสั่งซื้อ, เลข QT`
            : `search by name / order number / QT number`
        }
        className="TextField-without-border-radius"
        sx={{
          width: "100%",
          borderRadius: "16px",
        }}
        InputProps={{
          endAdornment: (
            <IconButton
              id="button-search-quotation"
              sx={{ padding: 0 }}
              onClick={() => {
                onSearch();
              }}
            >
              <SearchIcon
                sx={{
                  color: "#BF0013",
                  cursor: "pointer",
                }}
              />
            </IconButton>
          ),
        }}
        onChange={(e) => {
          setDataSearch((prev) => ({
            ...prev,
            keyword: e.target.value,
          }));
        }}
        onKeyUp={(e) => (e.code === "Enter" ? onSearch() : null)}
      />
    </WrapperText>
  );
};

export default SearchInput;
